/**
 * NotificationsContext.tsx
 *
 * Shares the single useNotifications instance (owned by AppLayout) across the
 * component tree. NotificationsPage reads from this context so it uses the
 * same state as the navbar bell — no duplicate fetches, shared unread count.
 */

import React, { createContext, useContext, type ReactNode } from 'react';
import type { UseNotificationsState } from '../hooks/useNotifications';

const NotificationsContext = createContext<UseNotificationsState | null>(null);

export function NotificationsProvider({
  children,
  value,
}: {
  children: ReactNode;
  value: UseNotificationsState;
}) {
  return <NotificationsContext.Provider value={value}>{children}</NotificationsContext.Provider>;
}

export function useNotificationsContext(): UseNotificationsState {
  const ctx = useContext(NotificationsContext);
  if (!ctx) {
    throw new Error('useNotificationsContext must be used within NotificationsProvider');
  }
  return ctx;
}
